import { render, staticRenderFns } from "./OnboardingThumbIcon.vue?vue&type=template&id=4b4a0774"
import script from "./OnboardingThumbIcon.vue?vue&type=script&lang=js"
export * from "./OnboardingThumbIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports